(function ($, Drupal) {
  'use strict';

  $(document).ready(function () {
    $('.mobile_menu_toggle').on("click", Drupal.debounce(function (element) {
      $(".region-primary-menu").toggleClass("open");
      $(this).find("*:not(.hidden)").removeClass("hidden");
      $(this).find(".hidden").removeClass("hidden");
      $(this).toggleClass("open");
      $('body').toggleClass("no-scroll");
    }, 200));
  });

})(jQuery, Drupal);
